import {
    Container,
    IconButton,
    Text,
    Box,
    WrapItem,
    useBreakpointValue,
    Center,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    useToast,
    Heading,
} from "@chakra-ui/react";

import ProductCard from "./ProductCard";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { getUserFavorites } from "../redux/actions/userActions";
import { setFavoritesUpdateFlag } from "../redux/slices/user";
import Slider from "react-slick";
import React, { useEffect } from "react";

import {
    getProducts,
    resetProductError,
} from "../redux/actions/productActions";


const TermekekCarousel = () => {

    const [slider, setSlider] = React.useState(null);

    const dispatch = useDispatch();

    const {
        loading,
        error,
        products,
        productUpdate,
    } = useSelector((state) => state.product);

    const { favoritesFlag } = useSelector((state) => state.user);

    const toast = useToast();

    const top = useBreakpointValue({
        base: "50%",
        md: "50%",
    });

    const side = useBreakpointValue({
        base: "4px",
        md: "-22px",
        lg: "-28px",
    });

    const slidesToShow = useBreakpointValue({
        base: 1,
        sm: 1,
        md: 3,
        lg: 4,
    });

    const dotsToShow = useBreakpointValue({
        base: false,
        md: false,
    });


    const settings = {
        dots: dotsToShow,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 5000,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
    };


    useEffect(() => {

        dispatch(getProducts());
        dispatch(resetProductError());

        if (productUpdate) {
            toast({
                description: "A termék frissítve lett.",
                status: "success",
                isClosable: true,
            });
        }

    }, [dispatch, toast, productUpdate]);


    useEffect(() => {

        const link1 = document.createElement("link");

        link1.rel = "stylesheet";
        link1.type = "text/css";
        link1.href =
            "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css";


        const link2 = document.createElement("link");

        link2.rel = "stylesheet";
        link2.type = "text/css";
        link2.href =
            "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css";


        document.head.appendChild(link1);
        document.head.appendChild(link2);


        return () => {

            document.head.removeChild(link1);
            document.head.removeChild(link2);

        };

    }, []);


    useEffect(() => {

        if (favoritesFlag) {

            dispatch(getUserFavorites());
            dispatch(setFavoritesUpdateFlag(false));

        }

    }, [favoritesFlag, dispatch]);


    return (

        <Box
            py={{
                base: 12,
                md: 16,
                lg: 20,
            }}
            bg="gray.50"
        >

            <Container
                maxW="container.xl"
                px={{
                    base: 4,
                    md: 6,
                }}
            >

                {/* FEJLÉC */}
                <Box
                    textAlign="center"
                    mb={{
                        base: 8,
                        md: 12,
                    }}
                >

                    <Text
                        fontFamily="'Poppins', sans-serif"
                        fontSize="sm"
                        fontWeight="600"
                        color="red.500"
                        textTransform="uppercase"
                        letterSpacing="2px"
                        mb={2}
                    >
                        Válogasson kínálatunkból
                    </Text>


                    <Heading
                        fontFamily="'Playfair Display', serif"
                        fontSize={{
                            base: "2xl",
                            md: "3xl",
                            lg: "4xl",
                        }}
                        fontWeight="700"
                        color="gray.800"
                        mb={3}
                    >
                        Tésztáink
                    </Heading>


                    <Text
                        fontFamily="'Poppins', sans-serif"
                        fontSize={{
                            base: "sm",
                            md: "md",
                        }}
                        color="gray.600"
                        maxW="600px"
                        mx="auto"
                        lineHeight="1.8"
                    >
                        Fedezze fel hagyományos, házias jellegű
                        száraztésztáink kínálatát.
                    </Text>

                </Box>


                {/* CAROUSEL */}
                <Box
                    position="relative"
                    px={{
                        base: 6,
                        md: 4,
                    }}
                >

                    {/* BAL NYÍL */}
                    <IconButton
                        aria-label="Előző termék"
                        icon={<BiLeftArrowAlt size="28px" />}
                        position="absolute"
                        left={side}
                        top={top}
                        transform="translateY(-50%)"
                        zIndex={2}

                        bg="white"
                        color="gray.700"

                        borderRadius="full"
                        boxShadow="md"

                        size={{
                            base: "sm",
                            md: "md",
                        }}

                        _hover={{
                            bg: "red.500",
                            color: "white",
                            transform: "translateY(-50%) scale(1.05)",
                        }}

                        transition="all 0.2s ease"

                        onClick={() => slider?.slickPrev()}
                    />


                    {/* JOBB NYÍL */}
                    <IconButton
                        aria-label="Következő termék"
                        icon={<BiRightArrowAlt size="28px" />}
                        position="absolute"
                        right={side}
                        top={top}
                        transform="translateY(-50%)"
                        zIndex={2}

                        bg="white"
                        color="gray.700"

                        borderRadius="full"
                        boxShadow="md"

                        size={{
                            base: "sm",
                            md: "md",
                        }}

                        _hover={{
                            bg: "red.500",
                            color: "white",
                            transform: "translateY(-50%) scale(1.05)",
                        }}

                        transition="all 0.2s ease"

                        onClick={() => slider?.slickNext()}
                    />


                    <style>
                        {`
                            .slick-slide > div {
                                padding: 0 8px;
                            }

                            .slick-list {
                                margin: 0 -8px;
                            }

                            .slick-dots {
                                position: relative;
                                margin-top: 10px;
                            }
                        `}
                    </style>


                    <Slider
                        {...settings}
                        ref={(slider) => setSlider(slider)}
                        style={{
                            width: "100%",
                        }}
                    >

                        {error ? (

                            <Alert status="error">
                                <AlertIcon />

                                <AlertTitle>
                                    Sajnáljuk!
                                </AlertTitle>

                                <AlertDescription>
                                    {error}
                                </AlertDescription>
                            </Alert>

                        ) : (

                            products.length > 0 ? (

                                products
                                    .slice(-25)
                                    .map((product) => (

                                        <WrapItem
                                            py={3}
                                            key={product._id}
                                            w="100%"
                                        >

                                            <Center w="100%">

                                                <ProductCard
                                                    product={product}
                                                    loading={loading}
                                                />

                                            </Center>

                                        </WrapItem>

                                    ))

                            ) : (

                                <Text
                                    textAlign="center"
                                    fontFamily="'Poppins', sans-serif"
                                    color="gray.500"
                                >
                                    Nincs elérhető termék.
                                </Text>

                            )

                        )}

                    </Slider>

                </Box>

            </Container>

        </Box>

    );
};


export default TermekekCarousel;